<div class="dialog-content">
  <h2 mat-dialog-title>VRChat Connection Failed</h2>
  <mat-dialog-content>
    <div style="display: flex; justify-content: center; align-items: center; gap: 50px; margin: 2rem 0 3rem 0">
        <img src="/img/jar.png" alt="Jar" style="width: 100px; height: 100px;">
        <app-icon icon="error" style="font-size: 50px;"></app-icon>
        <img src="/img/vrchat_icon.png" alt="VRChat" style="width: 100px; height: 100px;">
    </div>
    @if (!data.recovery_token) {
    <p>{{ data.message }}</p>
    } @else {
      <div style="margin: 2rem 0; padding: 1.5rem; border-radius: 4px;">
        <div>
          <h3 style="margin: 0;">Account Recovery</h3>
          <p style="margin: 0.5rem 0;">
            Your VRChat account is currently connected to a different account on jar.games.<br>
            You may have used a different Discord account so sign in in the past, or someone else has connected your VRChat account.<br>
          </p>
        </div>
        <p style="margin-bottom: 1rem;">To connect this VRChat account to your profile, follow these steps:</p>
        <div>
          
          <ol style="margin-bottom: 1.5rem; padding-left: 1.5rem;">
            <li>Copy the recovery token shown below</li>
            <li>Visit vrchat.com and go to your profile settings</li>
            <li>Paste the token anywhere in your bio</li>
            <li>Click "Retry Connection" below</li>
          </ol>
          
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Recovery Token</mat-label>
            <input matInput [value]="data.recovery_token" readonly>
            <button mat-icon-button matSuffix (click)="copyToken()" matTooltip="Copy token">
              <mat-icon>content_copy</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    }
    
    @if (data.discord_url && !data.recovery_token) {
      <div style="margin-top: 1rem; text-align: center;">
        <button mat-raised-button color="primary" (click)="openDiscord()">
          Get Help on Discord
        </button>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
    @if (data.recovery_token) {
      <button mat-raised-button color="primary" (click)="retryConnection()" [disabled]="retrying">
        @if (retrying) {
          Retrying...
        } @else {
          Retry Connection
        }
      </button>
    }
  </mat-dialog-actions>
</div>
